import { defineComponent as a, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as m, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const M = { key: 0 }, L = { key: 1 }, g = { key: 2 }, f = { key: 3 }, v = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconChartPie"
}, _ = /* @__PURE__ */ a({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const Z = s, { bind: d, weight: r } = u(Z);
    return (A, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      m(A.$slots, "default"),
      l(r) === "bold" ? (o(), e("g", M, t[0] || (t[0] = [
        n("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm12,24.87A84,84,0,0,1,194,76.07L140,107.22ZM50,159.17a83.94,83.94,0,0,1,66-114.3v76.2ZM128,212a83.88,83.88,0,0,1-65.95-32.07L206,96.83A84,84,0,0,1,128,212Z" }, null, -1)
      ]))) : l(r) === "duotone" ? (o(), e("g", L, t[1] || (t[1] = [
        n("path", {
          d: "M128,32v96L44.86,176h0A96,96,0,0,1,128,32Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm71.87,53.27L136,114.14V40.37A88,88,0,0,1,199.87,77.27ZM120,40.37v83l-71.89,41.5A88,88,0,0,1,120,40.37ZM128,216a88,88,0,0,1-71.87-37.27L207.89,91.12A88,88,0,0,1,128,216Z" }, null, -1)
      ]))) : l(r) === "fill" ? (o(), e("g", g, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,16a88,88,0,0,1,71.87,37.27L128,118.76Zm0,176a88,88,0,0,1-71.87-37.27L207.89,91.12A88,88,0,0,1,128,216Z" }, null, -1)
      ]))) : l(r) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        n("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm74.74,51.92L134,117.61V38.2A90,90,0,0,1,202.74,77.92ZM122,38.2v86.34L47.24,167.7A90,90,0,0,1,122,38.2ZM128,218a90,90,0,0,1-74.74-39.92L208.76,88.3A90,90,0,0,1,128,218Z" }, null, -1)
      ]))) : l(r) === "regular" ? (o(), e("g", v, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm71.87,53.27L136,114.14V40.37A88,88,0,0,1,199.87,77.27ZM120,40.37v83l-71.89,41.5A88,88,0,0,1,120,40.37ZM128,216a88,88,0,0,1-71.87-37.27L207.89,91.12A88,88,0,0,1,128,216Z" }, null, -1)
      ]))) : l(r) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        n("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm77.58,50.59L132,121.07v-85A92.07,92.07,0,0,1,205.58,78.59ZM124,36.09v89.6L46.42,170.48A92,92,0,0,1,124,36.09ZM128,220a92,92,0,0,1-77.58-42.59L209.58,85.52A92,92,0,0,1,128,220Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  _ as default
};
